import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import { messages } from './messages';
import { ChildrenPropType } from '../../../../prop-types/children';
import { OrderDetailsTabSection } from '../../tab-section/section';

import style from './rate-card-section.module.less';

export const RateCardSection = ({ className, children }) => {
  return (
    <OrderDetailsTabSection
      ariaLabelMessageDescriptor={messages.rateSectionAriaLabel}
      className={classnames(style['rate-card'], className)}
    >
      {children}
    </OrderDetailsTabSection>
  );
};

RateCardSection.propTypes = {
  className: PropTypes.string,
  children: ChildrenPropType.isRequired,
};
